import {
    searchBarStyles,
    searchBarInputLocationStyles,
    searchBarDistanceStyles,
    searchBarBedroomsStyles,
    searchBarFiltersButtonStyles,
    searchBarPriceRangeStyles,
    searchBarPropertyTypeStyles,
    searchBarSearchButtonStyles
} from './SearchBar.styles.css';

export const SearchBarLayout: React.FC<{
    children: React.ReactNode;
    layout: 'home' | 'lsrp' | 'newHomesLsrp';
    isFullWidthPage?: boolean;
    className?: string;
}> = ({ children, layout, isFullWidthPage, className }) => (
    <div
        role="region"
        aria-label="Search bar"
        className={`${searchBarStyles({
            layout,
            isFullWidthPage
        })} ${className}`}
    >
        {children}
    </div>
);

const searchBarElementStyles = {
    input: searchBarInputLocationStyles,
    distance: searchBarDistanceStyles,
    bedrooms: searchBarBedroomsStyles,
    price: searchBarPriceRangeStyles,
    propertyType: searchBarPropertyTypeStyles,
    filter: searchBarFiltersButtonStyles,
    search: searchBarSearchButtonStyles
};

export const SearchBarLayoutElement: React.FC<{
    children: React.ReactNode;
    type: keyof typeof searchBarElementStyles;
    className?: string;
}> = ({ children, type, className = '' }) => (
    <div className={`${searchBarElementStyles[type]} ${className}`}>
        {children}
    </div>
);
